import browserHistory from '../../../shared/history';

export function showShareDataModal() {
  if (browserHistory.location.pathname.endsWith('/share-data')) {
    return;
  }
  browserHistory.replace({
    pathname: `${browserHistory.location.pathname}/share-data`,
    state: {skipScrolling: true},
  });
}
